import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import InterestTitle from '../../../components/text/interestTitle'
import SimpleButton from '../../button/simple'

const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
`

const Interest = props => {
  return (
    <Container {...props}>
      <InterestTitle title={props.title} />
      <SimpleButton
        title="Estoy Interesado"
        onClick={() => props.toggleContact(!props.contactIsOpen)}
      />
    </Container>
  )
}

export default Interest



// WEBPACK FOOTER //
// ./src/components/section/interest/interest.js